export default "__VITE_ASSET__CujxphpP__"